/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef } from "react";
import "dayjs/locale/en-gb";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import SearchIcon from "@mui/icons-material/Search";
import { ModeloGetUrl, ModeloPost } from "../../ModeloCrud";
import CustomDataGrid from "../../CustomDataGrid";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuditoria } from "../contexts/AuditoriaContext";
import { useFormik } from "formik";
import * as yup from "yup";
import { Grid, Box, Typography, LinearProgress } from "@mui/material";
import DeleteModel from "../../DeleteModel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateField } from "@mui/x-date-pickers/DateField";
import { handleKeyDownField } from "../../utils/Utils";
import dayjs from "dayjs";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import ModalConfirmation from "../../modals/ModalConfirmation";

export default function RefacturarDerivacionesView({ listaRow, afterSave }) {
  const [searching, setSearching] = useState(false);
  const [adding, setAdding] = useState(false);
  const [refacturacionesRows, setRefacturacionesRows] = useState([]);
  const { auditoriaActivaId } = useAuditoria();
  const [deleteAjusteId, setDeleteAjusteId] = useState(null);
  const [cantidadResultados, setCantidadResultados] = useState(0);
  const [totalImporte, setTotalImporte] = useState(0);
  const [progress, setProgress] = useState(0);
  const [isRefacturando, setIsRefacturando] = useState(false);

  const viewportHeight = window.innerHeight;
  const gridHeight = viewportHeight - 300;
  const fechadesdeInputRef = useRef(null);
  const fechahastaInputRef = useRef(null);
  const searchInputRef = useRef(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const validationSchema = yup.object({
    fecha_desde: yup
      .date()
      .nullable()
      .typeError("Fecha inválida.")
      .required("Campo obligatorio."),
    fecha_hasta: yup
      .date()
      .min(
        yup.ref("fecha_desde."),
        "Fecha hasta debe ser mayor o igual a desde."
      )
      .nullable()
      .typeError("Fecha inválida.")
      .required("Campo obligatorio."),
  });

  const formik = useFormik({
    initialValues: {
      fecha_desde: dayjs(Date()),
      fecha_hasta: dayjs(Date()),
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleBuscarRefacturaciones(values);
    },
  });

  const CHUNK_SIZE = 10;
  const handleRefacturar = async () => {
    setShowConfirmationModal(false);
    const resultado_auditoria = "O";
    const auditoria_id = auditoriaActivaId;

    if (!refacturacionesRows.length) {
      toast.warning("No hay tratamientos seleccionados.");
      return;
    }

    const chunkArray = (arr, size) => {
      return arr.reduce(
        (acc, _, i) =>
          i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc,
        []
      );
    };

    const ids = refacturacionesRows.map((row) => row.id);
    const grupos = chunkArray(ids, CHUNK_SIZE);

    const errores = [];
    setIsRefacturando(true);
    setProgress(0);

    for (let i = 0; i < grupos.length; i++) {
      const grupo = grupos[i];
      try {
        const Data = {
          tratamientos: grupo.join(","),
          resultado_auditoria,
        };
        console.log("Enviando grupo:", grupo, "con datos:", Data);
        const res = await ModeloPost(
          "auditoria",
          auditoria_id,
          "refacturar-multiple",
          Data
        );
        console.log("Respuesta del servidor:", res);
        if (res.error) {
          toast.error(
            `Error al enviar grupo [${grupo.join(", ")}]: ${res.mensaje}`
          );
        }
      } catch (e) {
        errores.push(
          `Error de red o servidor al enviar grupo [${grupo.join(", ")}]: ${
            e.message
          }`
        );
      }

      // actualizar progreso
      setProgress(Math.round(((i + 1) / grupos.length) * 100));
    }

    setIsRefacturando(false);

    if (errores.length) {
      toast.error(
        `Errores en ${errores.length} tratamientos. Ver consola para más info.`
      );
      console.error("Errores de refacturación:", errores);
    } else {
      toast.success(
        "Todos los tratamientos fueron refacturados correctamente."
      );
    }
  };

  const handleQuitar = (row) => {
    setDeleteAjusteId(row.id);
  };

  const columnsObject = [
    { field: "id", headerName: "Id", width: 30 },
    { field: "codigo", headerName: "Código", width: 80 },
    { field: "fecha", headerName: "Fecha", width: 120 },
    {
      field: "documento",
      headerName: "Documento",
      width: 100,
    },
    {
      field: "nombre",
      headerName: "Paciente",
      width: 250,
      wrapLength: 200,
      textTransform: "capitalize",
    },
    { field: "especialidad", headerName: "Especialidad", width: 150 },
    {
      field: "odontologo",
      headerName: "Odontólogo",
      width: 250,
      wrapLength: 200,
      textTransform: "capitalize",
    },
    {
      field: "valor",
      headerName: "Importe",
      width: 120,
      align: "right",
      headerAlign: "right",
    },
  ];

  const handleBuscarRefacturaciones = async (values) => {
    try {
      setCantidadResultados(0);
      setTotalImporte(0);
      const params = {
        desde: values.fecha_desde.format().slice(0, 10),
        hasta: values.fecha_hasta.format().slice(0, 10),
      };
      console.log(
        "Parametros de búsqueda:",
        values.fecha_desde.format().slice(0, 10)
      );
      setSearching(true);
      const result = await ModeloPost(
        "auditoria",
        null,
        "derivaciones-no-refacturadas",
        params
      );
      setSearching(false);
      console.log("Resultado de búsqueda:", result);
      if (result.error) {
        toast.error("Error al buscar ajustes: " + result.mensaje);
      } else if (result.listado?.length) {
        console.log("Refacturaciones encontrados:", result.listado);
        if (result?.listado) {
          setCantidadResultados(result.listado.length);
          const total = result.listado.reduce(
            (sum, item) => sum + Number(item.valor || 0),
            0
          );
          setTotalImporte(total);
        }
        setRefacturacionesRows(result.listado);
      } else {
        setRefacturacionesRows([]);
      }
    } catch (error) {
      toast.error("Error al buscar ajustes: " + error.message);
      setSearching(false);
    }
  };

  return (
    <Grid container spacing={2}>
      {/* Formulario en una línea */}
      <Grid
        container
        spacing={2}
        sx={{
          paddingBottom: 2,
          borderBottom: 1,
          borderColor: "grey.400",
          mt: 2,
        }}
      >
        <Grid item xs={12} md={6} lg={2}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={"en-gb"}
          >
            <DateField
              id="fecha_desde"
              label="Desde"
              inputRef={(el) => (fechadesdeInputRef.current = el)}
              value={formik.values.fecha_desde}
              inputFormat="DD/MM/YYYY"
              format="DD/MM/YYYY"
              onChange={(value) => formik.setFieldValue("fecha_desde", value)}
              size="small"
              helperText={
                formik.touched.fecha_desde ? formik.errors.fecha_desde : ""
              }
              error={
                formik.touched.fecha_desde && Boolean(formik.errors.fecha_desde)
              }
              onKeyDown={(e) => handleKeyDownField(e, fechahastaInputRef)}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={"en-gb"}
          >
            <DateField
              id="fecha_hasta"
              label="Hasta"
              inputRef={(el) => (fechahastaInputRef.current = el)}
              value={formik.values.fecha_hasta}
              inputFormat="DD/MM/YYYY"
              format="DD/MM/YYYY"
              onChange={(value) => formik.setFieldValue("fecha_hasta", value)}
              size="small"
              helperText={formik.errors.fecha_hasta}
              error={Boolean(formik.errors.fecha_hasta)}
              onKeyDown={(e) => handleKeyDownField(e, searchInputRef)}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} lg={2}>
          <LoadingButton
            size="medium"
            inputRef={(el) => (searchInputRef.current = el)}
            onClick={formik.handleSubmit}
            loading={searching}
            loadingPosition="start"
            endIcon={<SearchIcon />}
            sx={{
              backgroundColor: "primary.main",
              ":hover": {
                bgcolor: "#475569", // theme.palette.primary.main
                color: "white",
              },
              width: 80,
              marginTop: { xs: 3, md: 0.5 },
              marginLeft: { xs: 0, md: 1 },
            }}
            variant="contained"
          >
            <span></span>
          </LoadingButton>
        </Grid>
        <Grid item xs={12} lg={2} display="flex" alignItems="center">
          {cantidadResultados > 0 && (
            <Box ml={2}>
              <Typography variant="body2">
                Cantidad: <strong>{cantidadResultados}</strong>
              </Typography>
              <Typography variant="body2">
                Total: <strong>${totalImporte.toFixed(2)}</strong>
              </Typography>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} lg={2}>
          {cantidadResultados > 0 && (
            <LoadingButton
              size="medium"
              inputRef={(el) => (searchInputRef.current = el)}
              onClick={() => setShowConfirmationModal(true)}
              loading={searching}
              loadingPosition="start"
              endIcon={<PublishedWithChangesIcon />}
              sx={{
                backgroundColor: "primary.main",
                ":hover": {
                  bgcolor: "#475569", // theme.palette.primary.main
                  color: "white",
                },
                width: 200,
                marginTop: { xs: 3, md: 0.5 },
                marginLeft: { xs: 0, md: 1 },
              }}
              variant="contained"
            >
              <span>Refacturar</span>
            </LoadingButton>
          )}
        </Grid>
      </Grid>
      {isRefacturando && (
        <Box sx={{ width: "100%", my: 2 }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      )}

      {/* Tabla de ajustes */}
      <Grid item xs={12}>
        {!searching && !adding && refacturacionesRows?.length > 0 && (
          <CustomDataGrid
            columnsObject={columnsObject}
            dataRows={refacturacionesRows}
            pageSize={100}
            height={gridHeight}
            columnPercentage={0.4}
          />
        )}
      </Grid>
      {deleteAjusteId !== null && (
        <DeleteModel
          model={"liquidacion-ajuste"}
          modelid={deleteAjusteId}
          okmethod={handleBuscarRefacturaciones}
          nullmethod={setDeleteAjusteId}
        />
      )}
      <ModalConfirmation
        showModal={showConfirmationModal}
        confirmModal={handleRefacturar}
        hideModal={() => setShowConfirmationModal(false)}
        message={"Seguro quiere refacturar todo ?"}
      />
    </Grid>
  );
}
